import { render } from "./LazyLoader.vue?vue&type=template&id=64404368&scoped=true"
import script from "./LazyLoader.vue?vue&type=script&lang=js"
export * from "./LazyLoader.vue?vue&type=script&lang=js"

import "./LazyLoader.vue?vue&type=style&index=0&id=64404368&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64404368"]])

export default __exports__